import React from 'react';
import { ValidatorComponent } from 'react-form-validator-core';
import classNames from 'classnames';

import './input.scss';

class TextValidator extends ValidatorComponent {
  componentDidUpdate(prevProps, prevState) {
    const { setError, value } = this.props;
    if (setError && this.state.isValid !== prevState.isValid) {
      setError(this.state.isValid, this.getErrorMessage());
    }
    if (setError && value !== prevProps.value) {
      setError(true, '');
    }
  }

  render() {
    const {
      errorMessages,
      validators,
      requiredError,
      validatorListener,
      title,
      formValid,
      icon: Icon,
      style = {},
      fullWidth = false,
      handleClick,
      hide,
      setError,
      ...rest
    } = this.props;

    const error = this.errorText();
    const inputClass = classNames('custom-input', {
      error: error || !formValid,
      'full-width': fullWidth,
    });

    const mainWrapper = classNames('main-wrapper', {
      hide: hide,
    });

    return (
      <div className={mainWrapper} style={style}>
        <div className={inputClass}>
          {title && <label>{title}</label>}
          <input {...rest} />
          {Icon && (
            <div className="icon-wrapper" onClick={handleClick}>
              <Icon />
            </div>
          )}
        </div>
        {formValid && <div className="error-msg">{error}</div>}
      </div>
    );
  }

  errorText() {
    const { isValid } = this.state;

    if (isValid) {
      return null;
    }

    return <div>{this.getErrorMessage()}</div>;
  }
}

export default TextValidator;
